"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEarthFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm7.61 18.45a8.34 8.34 0 01-.45 2.72l-1 3.14A11.83 11.83 0 0116.72 28v-3.66a.91.91 0 00-.67-.88l-.72-.19A2.88 2.88 0 0113.22 20l.49-3-3.33-.71a2.93 2.93 0 01-2.26-2.44l-.86-6a11.91 11.91 0 0112.88-3l-.53 2.52a2.9 2.9 0 01-1.92 2.17L14 10.66a.89.89 0 00-.58.64l-.71 3.44 8.59 1.84a2.93 2.93 0 012.3 2.84z" })));
}
exports.default = SvgEarthFilled;
//# sourceMappingURL=EarthFilled.js.map